export default "__VITE_PUBLIC_ASSET__eb8ad787__"